export default __webpack_public_path__ + "static/media/defaultCover.8fdc37c3.gif";